import TrainingAttachment from '../attachment';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingAttachment.store((data, fetch) => {
    // Prepare request
    let formData = new FormData();
    ['order_index', 'attachment_data', 'attachment_type', 'file']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings/${data.trainingId}/attachments`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
